import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const AlertCircleRed = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 32, height = 32, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M22.6665 4.45352C24.6775 5.61466 26.3504 7.28088 27.5196 9.28725C28.6888 11.2936 29.3137 13.5705 29.3324 15.8926C29.3512 18.2147 28.7631 20.5015 27.6265 22.5264C26.4899 24.5514 24.8442 26.2445 22.8522 27.4379C20.8602 28.6314 18.591 29.284 16.2693 29.3309C13.9476 29.3779 11.6539 28.8177 9.61524 27.7058C7.57658 26.5939 5.86367 24.9689 4.64606 22.9915C3.34485 20.8784 2.70464 18.4712 2.6665 16.0002C2.70436 13.5474 3.33492 11.1574 4.61802 9.05484C5.81815 7.08822 7.50738 5.46612 9.52103 4.34669C11.5347 3.22727 13.804 2.64871 16.1078 2.66743C18.4117 2.68615 20.6713 3.30151 22.6665 4.45352Z"
          fill="#F2544B"
        />
        <path
          d="M16.0132 19.9992L15.8438 20.0085C15.5198 20.0471 15.2211 20.2031 15.0044 20.4471C14.7877 20.6912 14.668 21.0062 14.668 21.3325C14.668 21.6589 14.7877 21.9739 15.0044 22.2179C15.2211 22.4619 15.5198 22.618 15.8438 22.6565L15.9998 22.6659L16.1692 22.6565C16.4932 22.618 16.7919 22.4619 17.0086 22.2179C17.2253 21.9739 17.345 21.6589 17.345 21.3325C17.345 21.0062 17.2253 20.6912 17.0086 20.4471C16.7919 20.2031 16.4932 20.0471 16.1692 20.0085L16.0132 19.9992ZM15.9998 9.33252C15.6733 9.33256 15.3581 9.45246 15.114 9.66947C14.87 9.88648 14.714 10.1855 14.6758 10.5099L14.6665 10.6659V15.9992L14.6758 16.1552C14.7144 16.4793 14.8704 16.7779 15.1145 16.9946C15.3585 17.2113 15.6735 17.331 15.9998 17.331C16.3262 17.331 16.6412 17.2113 16.8852 16.9946C17.1292 16.7779 17.2853 16.4793 17.3238 16.1552L17.3332 15.9992V10.6659L17.3238 10.5099C17.2856 10.1855 17.1297 9.88648 16.8857 9.66947C16.6416 9.45246 16.3264 9.33256 15.9998 9.33252Z"
          fill="white"
        />
      </svg>
    );
  },
);
